<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="primary"
            small
            depressed
            text
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            class="px-0"
          >
            <v-icon small>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>Reports</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="report in filteredReportTypes"
        :key="report.id"
        @click="download(report)"
        ><v-icon class="mr-2">{{ report.icon }}</v-icon
        >{{ report.name }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: ["appointmentId"],
  computed: {
    reportTypes() {
      return [
        {
          id: 1,
          name: "Assessment Certification",
          icon: "mdi-file-edit-outline",
          path: "generateIDEPAssessmentCertification",
        },
        {
          id: 2,
          name: "Assessment Recommendation",
          icon: "mdi-file-check-outline",
          path: "generateIDEPAssessmentRecommendation",
        },
        {
          id: 3,
          name: "Denial Letter",
          icon: "mdi-file-document-outline",
          path: "generateIDEPAssessmentDenialLetter",
          hide: this.appointment.recommendation !== "Denied",
        },
      ];
    },
    filteredReportTypes() {
      return this.reportTypes.filter((x) => !x.hide);
    },
    appointment() {
      return this.$store.getters["appointmentsModule/getAppointmentById"](
        this.appointmentId
      );
    },
  },
  methods: {
    async download(report) {
      this.$store.commit("uxModule/setShowLoader", true);

      var url =
        process.env.VUE_APP_OMNI_BASE_URL +
        "/api/mta/" +
        report.path +
        "?mtaAppointmentId=" +
        this.appointmentId;
      window.open(url);

      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
